import React from 'react'
import { Profile } from '../components'

export default function ProfilePage() {
    return <Profile />
}
